import { connect } from 'react-redux'
import { bindActionCreators, Dispatch } from 'redux'
import { UploadSourcesEnum } from '@medentee/enums'
import { FC } from 'react'

import { State } from 'redux/rootReducer'
import {
  createProcessingSelector,
  createLoadingSelector,
  removeErrorNotification,
  getChatMedCloudFilesRequest,
  attachSelectedChatMedCloudFilesRequest,
  resetAttachFilesAction,
  ATTACH_SELECTED_CHAT_MED_CLOUD_FILES,
  GET_CHAT_MED_CLOUD_FILES
} from 'store'
import {
  FileAttachDialog,
  TFileAttachDialogPropsOwnProps
} from 'App/components/File/FileAttachDialog'

export type TChatAttachFileDialogContainerProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>

const loadingSelector = createLoadingSelector([GET_CHAT_MED_CLOUD_FILES])
const processingSelector = createProcessingSelector([ATTACH_SELECTED_CHAT_MED_CLOUD_FILES])

const mapStateToProps = (state: State) => ({
  loading: loadingSelector(state),
  processing: processingSelector(state),
  error: state.errors[ATTACH_SELECTED_CHAT_MED_CLOUD_FILES],
  fileIds: state.medCloud.attachFiles.ids,
  selectedFileIds: state.medCloud.attachFiles.selectedFiles,
  total: state.medCloud.attachFiles.total,
  uploadFileIds: state.medCloud.attachFiles.uploadingFiles,
  search: state.medCloud.filters.search,
  uploadedFrom: UploadSourcesEnum.CHAT
})

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      getChatMedCloudFiles: getChatMedCloudFilesRequest,
      attachSelectedFilesToChat: attachSelectedChatMedCloudFilesRequest,
      hideAttachModal: resetAttachFilesAction,
      removeErrorNotification: () => removeErrorNotification(ATTACH_SELECTED_CHAT_MED_CLOUD_FILES)
    },
    dispatch
  )

export const ChatAttachFileDialogContainer: FC<TFileAttachDialogPropsOwnProps> = connect(
  mapStateToProps,
  mapDispatchToProps
)(FileAttachDialog)
